<footer class="tab_navigation" *ngIf="exibir">
  <img class="header-logo" src="assets/images/logos/cacaulovers.png" />
  <div class="tabs_container">
    <div matTooltip="Início">
      <img class="tabs__menu_icones" src="assets/images/icons/home.png" (click)="redirecionarHome()" />
      <span class="tab__legenda">Início</span>
      <!-- <span class="fa fa-home" (click)="redirecionarHome()"></span> -->
    </div>
    <div matTooltip="Compras">
      <a class="link_cacau" (click)="redirecionarEcommerce()">
        <img class="logo_cacau" src="assets/images/logos/cs.png" alt="CS">
      </a>
      <span class="tab__legenda">Compras</span>
    </div>
    <div matTooltip="Perfil">
      <img class="tabs__menu_icones" src="assets/images/icons/perfil.png" (click)="redirecionarPerfil()" />
      <span class="tab__legenda">Perfil</span>
      <!-- <span class="fa fa-user" (click)="redirecionarPerfil()"></span> -->
    </div>
  </div>
  <div class="desconectar_container">
    <button class="cs_botao desconectar_botao" (click)="desconectar()">
      SAIR
    </button>
  </div>
</footer>